export const visitLogsKeys = {
  all: ['visit-logs'] as const,
  lists: () => [...visitLogsKeys.all, 'list'] as const,
  list: (id: number) => [...visitLogsKeys.lists(), { id }] as const,
};
